exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.__em-selectlist .mint-picker-column__frame {\r\n    position: absolute;\n}\n.__em-selectlist .__em-selectlist-group {\r\n    max-height: 250px;\r\n    overflow: auto;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-40b567a9!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/emapm-form/emapComponents/emSelectlist.vue
// module id = 168
// module chunks = 0